import React from 'react'

// Patient finance (Paul 2026-09-30): the loan table beside its full cost (NCA Regulation 21(3)), shown
// AFTER the plan and the cash total, with a link to the finance application. Used on the case page (/c/…)
// and the treatment-plan page (/j/…). The server decides who sees it (FinanceProgram.panel_props) and
// supplies every figure — nothing is calculated here.
export default function FinancePanel({ finance }) {
  if (!finance) return null
  const rows = finance.rows || []
  const anyShort = rows.some((r) => r.short_term)
  return (
    <div className="rounded-2xl border border-brand-border bg-white p-5 shadow-sm">
      <h2 className="text-sm font-semibold text-brand-ink">Spread the cost (optional)</h2>
      {finance.choice_note && <p className="mt-1 text-xs leading-relaxed text-brand-muted">{finance.choice_note}</p>}
      <div className="mt-3 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-brand-border text-left text-xs uppercase tracking-wide text-brand-muted">
              <th className="py-2 pr-2">Term</th><th className="py-2 pr-2 text-right">Monthly</th><th className="py-2 text-right">Total</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.months} className="border-b border-brand-border/60">
                <th className="py-2 pr-2 text-left font-semibold text-brand-ink">{r.months} months{r.short_term ? ' *' : ''}</th>
                <td className="py-2 pr-2 text-right tabular-nums">{r.instalment}</td>
                <td className="py-2 text-right tabular-nums">{r.total}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {anyShort && <p className="mt-2 text-xs text-brand-muted">* Short-term credit, priced per month.</p>}
      <p className="mt-3 text-xs leading-relaxed text-brand-muted">{finance.disclosure}</p>
      {finance.unconfirmed_note && <p className="mt-1 text-xs leading-relaxed text-amber-700">{finance.unconfirmed_note}</p>}
      <p className="mt-1 text-xs leading-relaxed text-brand-muted">{finance.optional_note}</p>
      <a href={finance.apply_url}
         className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-lg border-2 border-brand-primary px-4 py-2.5 text-sm font-semibold text-brand-primary transition hover:bg-brand-accent">
        See my payment options
      </a>
    </div>
  )
}
